import { render, staticRenderFns } from "./Dispositivos.vue?vue&type=template&id=297338a8&scoped=true"
import script from "./Dispositivos.vue?vue&type=script&lang=ts"
export * from "./Dispositivos.vue?vue&type=script&lang=ts"
import style0 from "./Dispositivos.vue?vue&type=style&index=0&id=297338a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297338a8",
  null
  
)

export default component.exports